import { render, staticRenderFns } from "./BreadcrumbsItem.vue?vue&type=template&id=2aa0d295&"
import script from "./BreadcrumbsItem.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BreadcrumbsItem.vue"
export default component.exports